export default "__VITE_ASSET__BmjYEW9a__"